import { service, handleResponse, handleError } from "./apiService";
import * as apiUtils from "./apiUtils";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default {
    artist(url = baseUrl + '/artist/') {
        return {
            fetchAll: async (searchText, pageNo, pageSize) => {
                return service.get(url, {
                    params: {
                        searchText: searchText,
                        pageNo: pageNo,
                        pageSize: pageSize
                    },
                    paramsSerializer: params => apiUtils.parseParams(params),
                });
            },
            fetchById: async id => service.get(url + id),
            create: async newRecord => service.post(url, newRecord),
            update: async (id, updateRecord) => service.put(url + id, updateRecord),
            delete: async id => service.delete(url + id),
            fetchWithAlbums: async (artistIds, searchField, searchText, pageNo, pageSize) => {
                return service.get(url + 'artistwithalbums', {
                    params: {
                        artistIds: artistIds,
                        searchField: searchField,
                        searchText: searchText,
                        pageNo: pageNo,
                        pageSize: pageSize
                    },
                    paramsSerializer: params => apiUtils.parseParams(params),
                });
            }
        }
    }
}